import React, { useState, useEffect } from 'react'
import getTickets from 'services/getTickets'

import './Home.css'
import Loader from 'components/Loader'
import NavBar from 'components/NavBar'
import ListOfTickets from 'components/ListOfTickets'

function Home () {
  const [isLoading, setLoading] = useState(false)
  const [tickets, setTickets] = useState([])

  function refreshInfo () {
    setLoading(true)
    getTickets()
    //      .then(t => { console.log(t); return t })
      .then(t => {
        setTickets(t)
        setLoading(false)
      })
      .catch(e => {
        setLoading(false)
        console.log(...e.error)
      })
  }

  useEffect(() => {
    setLoading(true)
    getTickets()
    //      .then(t => { console.log(t); return t })
      .then(t => {
        setTickets(t)
        setLoading(false)
      })
      .catch(e => {
        setLoading(false)
        console.log(...e.error)
      })
  }, [])

  return (
    <>
      <NavBar refreshInfo={refreshInfo} />
      <main className='Home'>
        {isLoading
          ? <Loader />
          : tickets.length === 0
            ? <p>No hay sucesos ni acciones activas</p>
            : <ListOfTickets tickets={tickets} />}
      </main>
    </>
  )
}

export default Home
